import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Menu, X } from 'lucide-react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on navigation
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header 
      className={`sticky top-0 z-50 transition-all duration-200 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-white'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Main navigation">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
            aria-label="Make Resume Free home"
          >
            <FileText className="h-6 w-6 text-teal-600 group-hover:text-teal-700 transition-colors" />
            <span className="font-bold text-lg sm:text-xl bg-gradient-to-r from-teal-600 to-teal-500 bg-clip-text text-transparent">
              Make Resume Free
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <div className="flex items-center gap-6">
              <Link 
                to="/tips" 
                className="text-sm font-medium text-gray-600 hover:text-teal-600 transition-colors"
              >
                Resume Tips
              </Link>
              <Link 
                to="/faq" 
                className="text-sm font-medium text-gray-600 hover:text-teal-600 transition-colors"
              >
                FAQ
              </Link>
            </div>
            <Link 
              to="/resume" 
              className="inline-flex items-center justify-center px-4 py-2 bg-teal-600 text-sm font-medium text-white rounded-lg hover:bg-teal-700 transition-colors"
            >
              Create Free Resume
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-teal-600 transition-colors"
            aria-expanded={isMenuOpen}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`
            md:hidden border-t border-gray-100
            transform transition-all duration-300 ease-in-out
            ${isMenuOpen ? 'opacity-100 h-auto py-4' : 'opacity-0 h-0 pointer-events-none'}
          `}
          aria-hidden={!isMenuOpen}
        >
          <div className="space-y-1">
            <Link 
              to="/tips"
              className="block px-4 py-2 text-gray-600 hover:text-teal-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Resume Tips
            </Link>
            <Link 
              to="/faq"
              className="block px-4 py-2 text-gray-600 hover:text-teal-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            <Link 
              to="/resume"
              className="block px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 text-center font-medium"
              onClick={() => setIsMenuOpen(false)}
            >
              Create Free Resume
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}